import { all, call, put } from 'redux-saga/effects';

import { getBlankCarInstance } from 'data-providers/carInstanceProvider';
import { createBlancUser } from 'data-providers/startPage';
import * as CarInstanceActions from 'store/carInstance/actions';
import { selectWhen } from 'store/helpers';
import * as StartPageActions from 'store/startPage';
import * as UserSelectors from 'store/user/selectors';

import * as InsuranceConstants from '../../constants';
import { CreateStage } from '../../helpers';

export const insuranceStageCreateNewInsurance = new CreateStage({
  action: InsuranceConstants.ACTIONS.CREATE_NEW_INSURANCE,
  handler: function* () {
    const dealerId = yield selectWhen(UserSelectors.getDealerId);

    const [customer, carInstance] = yield all([
      call(createBlancUser),
      call(getBlankCarInstance, dealerId),
    ]);

    yield put(StartPageActions.setCustomer(customer));
    yield put(CarInstanceActions.setCarInstance(carInstance));
  },
  name: InsuranceConstants.STAGES_FIELDS.CREATE_NEW_INSURANCE,
}).watcher;
